import './FeaturedProjectCard.css';

function FeaturedProjectCard({ title, description, image, tech, demo }) {
  return (
    <article className="featured-project-card">
      <img src={image} alt={`${title} screenshot`} className="featured-project-image" />
      <div className="featured-project-content">
        <h3>{title}</h3>
        <p>{description}</p>
        <div className="featured-project-tech">{tech && tech.join(', ')}</div>
        <div className="featured-project-links">
          {demo && (
            <a
              href={demo}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Visit ${title} (opens in new window)`}
            >
              Visit Site
            </a>
          )}
        </div>
      </div>
    </article>
  );
}

export default FeaturedProjectCard;
